import { categories } from '@/mocks/comics';

export default function CategorySection() {
  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            漫画分类
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            六大热门分类，轻松找到你喜欢的漫画类型
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat, idx) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-xl bg-background-100 hover:bg-primary-50 p-5 md:p-6 text-center transition-all duration-300 hover:-translate-y-1"
              style={{ animationDelay: `${idx * 0.08}s` }}
            >
              <div className="w-12 h-12 md:w-14 md:h-14 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100 group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${cat.icon} text-xl md:text-2xl text-primary-500 group-hover:text-background-50 transition-colors duration-300`}></i>
              </div>
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-800 group-hover:text-primary-600 whitespace-nowrap transition-colors duration-300">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 mt-1">
                {cat.name}漫画
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}